export default "__VITE_ASSET__BiRdXLaT__"